<template>
  <default-layout>
    <event-navbar :title="t('view.title')" />
    <exhibitor-scan />
  </default-layout>
</template>

<script>
import EventNavbar from '@/components/EventNavbar.vue'
import DefaultLayout from '@/components/DefaultLayout.vue'
import ExhibitorScan from '@/components/visitor-lead/ExhibitorScan.vue'
import { getVisitorLeadLocale, translateVisitorLead } from '@/components/visitor-lead/i18n.js'

export default {
  name: 'ExhibitorScanView',
  components: { DefaultLayout, EventNavbar, ExhibitorScan },
  methods: {
    t(key) {
      return translateVisitorLead(key, {}, getVisitorLeadLocale())
    },
  },
}
</script>
